__turbopack_context__.v({
  "--requires-scrolling": "demonstrate-success-step-module-scss-module__N8R7XW__--requires-scrolling",
  "__additional-fields-table": "demonstrate-success-step-module-scss-module__N8R7XW____additional-fields-table",
  "__banner-header": "demonstrate-success-step-module-scss-module__N8R7XW____banner-header",
  "__container": "demonstrate-success-step-module-scss-module__N8R7XW____container",
  "__key": "demonstrate-success-step-module-scss-module__N8R7XW____key",
  "__success-message": "demonstrate-success-step-module-scss-module__N8R7XW____success-message",
  "__value": "demonstrate-success-step-module-scss-module__N8R7XW____value",
  "__value-image": "demonstrate-success-step-module-scss-module__N8R7XW____value-image",
  "demonstrate-success-step": "demonstrate-success-step-module-scss-module__N8R7XW__demonstrate-success-step",
});
